import { render, staticRenderFns } from "./compliance_info.vue.js?vue&type=template&id=cbc0388e&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./compliance_info.vue?vue&type=template&id=cbc0388e&vue3"
import script from "./compliance_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./compliance_info.vue?vue&type=script&lang=js&vue3"
export * from "./compliance_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./compliance_info.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports